import { render, staticRenderFns } from "./HotelDescriptions.vue?vue&type=template&id=1ba6a28a&scoped=true"
import script from "./HotelDescriptions.vue?vue&type=script&lang=js"
export * from "./HotelDescriptions.vue?vue&type=script&lang=js"
import style0 from "./HotelDescriptions.vue?vue&type=style&index=0&id=1ba6a28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6a28a",
  null
  
)

export default component.exports